<div class="row">
  @if (labelName) {
    <div class="col-md-4 col-12">
      <label
        class="control-label"
        for="{{ labelName ? labelName : 'inputText' }}"
      >
        <span [ngClass]="required ? 'required' : 'hide'">*</span>
        {{ labelName }}
      </label>
    </div>
  }
  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      #inputText
      (blur)="emitBlur()"
      (ngModelChange)="changeModel($event)"
      [ngClass]="{
        requiredField: !isValid && !submitted && !isReadOnly,
        errorRequiredField: !isValid && submitted && !isReadOnly,
      }"
      [ngModel]="inputModel"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="placeholder"
      class="form-control"
      id="{{ labelName ? labelName : 'inputText' }}"
      name="{{ labelName ? labelName : 'inputText' }}"
      type="text"
      [disabled]="isReadOnly"
    />
  </div>
  @if (environment.useDebugMode) {
    <pre>
      inputModel: {{ inputModel }}
      isValid {{ isValid }}</pre>
  }
  @if (submitted && !isValid && !isReadOnly) {
    <div class="col-12 errorText" id="validationError">
      <i class="fa fa-circle-o fa-lg circle-position"></i>
      <i class="fa fa-exclamation exclamation-position"></i>
      @if (!errorMessage) {
        <p class="col ps-2 ms-4 input-validation-text">
          Entry cannot be empty.
        </p>
      }
      @if (errorMessage) {
        <p class="col ps-2 ms-4 input-validation-text">
          {{ errorMessage }}
        </p>
      }
    </div>
  }
  @if (!submitted || isValid || isReadOnly) {
    <div class="col-12">
      <p></p>
    </div>
  }
</div>
